import { CheckCircle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

interface FormStepsProps {
  currentStep: number;
}

export function FormSteps({ currentStep }: FormStepsProps) {
  const { t } = useLanguage();
  
  const steps = [
    { number: 1, title: t('buyingForm.step1') },
    { number: 2, title: t('buyingForm.step2') },
    { number: 3, title: t('buyingForm.step3') },
    { number: 4, title: t('buyingForm.step4') }
  ];

  return (
    <div className="w-full mb-8 px-4">
      <div className="flex items-center justify-center max-w-4xl mx-auto">
        {steps.map((step, index) => (
          <div key={step.number} className="flex items-center flex-1 justify-center">
            <div className="flex flex-col items-center">
              <div className={`flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full border-2 transition-all duration-200 ${
                step.number === currentStep 
                  ? 'border-[#f91bdc] bg-[#f91bdc] text-white' 
                  : step.number < currentStep 
                    ? 'border-green-500 bg-green-500 text-white'
                    : 'border-gray-300 bg-white text-gray-400'
              }`}>
                {step.number < currentStep ? <CheckCircle size={16} className="sm:w-5 sm:h-5" /> : step.number}
              </div>
              <div className="mt-2 text-center">
                <p className={`text-xs sm:text-sm font-medium max-w-20 sm:max-w-none ${
                  step.number === currentStep ? 'text-[#f91bdc]' : step.number < currentStep ? 'text-green-600' : 'text-gray-400'
                }`}>
                  {step.title}
                </p>
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className={`flex-1 h-0.5 mx-2 sm:mx-4 max-w-16 sm:max-w-20 ${
                step.number < currentStep ? 'bg-green-500' : 'bg-gray-200'
              }`} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}